module.exports = __webpack_public_path__ + "prod-assets/doorframe-93b7c7.obj";


//////////////////
// WEBPACK FOOTER
// ./assets/doorframe.obj
// module id = 19
// module chunks = 0